import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedData } from '../models/BaseResponse';
import { environment } from '../../environments/environment';
import { ParkingArea } from '../models/ParkingArea';

@Injectable({
  providedIn: 'root'
})
export class ParkingAreaService {

  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: ParkingArea): Observable<PagedData<ParkingArea>> {
    return this.httpClient.post<PagedData<ParkingArea>>(environment.apiUrl + "parking-areas/filtered", searchCriteria);
  }

  findById(id: number): Observable<ParkingArea> {
    return this.httpClient.get<ParkingArea>(`${environment.apiUrl}parking-areas/${id}`);
  }

  cloneById(id: number): Observable<ParkingArea> {
    return this.httpClient.post<ParkingArea>(`${environment.apiUrl}parking-areas/clone/${id}`, null);
  }

  switchStatus(id: number): Observable<ParkingArea> {
    return this.httpClient.post<ParkingArea>(`${environment.apiUrl}parking-areas/switchStatus/${id}`, null);
  }


  delete(id: number | string): Observable<void> {
    return this.httpClient.delete<void>(`${environment.apiUrl}parking-areas/${id}`);
  }

  save(parkingArea: ParkingArea): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "parking-areas", parkingArea);
  }

}
